// node_modules/personnummer/dist/esm/index.js
var PersonnummerError = class extends Error {
  constructor() {
    super("Invalid swedish personal identity number");
  }
};
var compareAsc = (dateLeft, dateRight) => {
  const diff = dateLeft.getTime() - dateRight.getTime();
  return diff < 0 ? -1 : diff > 0 ? 1 : diff;
};
var diffInYears = (dateLeft, dateRight) => {
  const sign = compareAsc(dateLeft, dateRight);
  const yearDiff = Math.abs(dateLeft.getFullYear() - dateRight.getFullYear());
  dateLeft.setFullYear(dateLeft.getFullYear() - sign * yearDiff);
  const isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
  const result = sign * (yearDiff - +isLastYearNotFull);
  return result === 0 ? 0 : result;
};
var luhn = (str) => {
  let sum = 0;
  str += "";
  for (let i = 0, l = str.length; i < l; i++) {
    let v = parseInt(str[i]);
    v *= 2 - i % 2;
    if (v > 9) {
      v -= 9;
    }
    sum += v;
  }
  return Math.ceil(sum / 10) * 10 - sum;
};
var testDate = (year, month, day) => {
  month -= 1;
  const date = new Date(year, month, day);
  return !(date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day);
};
var Personnummer = class {
  constructor(ssn, options) {
    this._century = "";
    this._fullYear = "";
    this._year = "";
    this._month = "";
    this._day = "";
    this._sep = "";
    this._num = "";
    this._check = "";
    this.parse(ssn, options);
  }
  get century() {
    return this._century;
  }
  get fullYear() {
    return this._fullYear;
  }
  get year() {
    return this._year;
  }
  get month() {
    return this._month;
  }
  get day() {
    return this._day;
  }
  get sep() {
    return this._sep;
  }
  get num() {
    return this._num;
  }
  get check() {
    return this._check;
  }
  static parse(ssn, options) {
    return new Personnummer(ssn, options);
  }
  static valid(ssn, options) {
    try {
      Personnummer.parse(ssn, options);
      return true;
    } catch (e) {
      return false;
    }
  }
  parse(ssn, options) {
    const reg = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([+\-]?)((?!000)\d{3})(\d)$/;
    const match = reg.exec(ssn);
    if (!match) {
      throw new PersonnummerError();
    }
    const century = match[1];
    const year = match[2];
    const month = match[3];
    const day = match[4];
    const sep = match[5];
    const num = match[6];
    const check = match[7];
    if (typeof century === "undefined" || !century.length) {
      const d = new Date();
      let baseYear = 0;
      if (sep === "+") {
        this._sep = "+";
        baseYear = d.getFullYear() - 100;
      } else {
        this._sep = "-";
        baseYear = d.getFullYear();
      }
      this._century = ("" + (baseYear - (baseYear - parseInt(year)) % 100)).substr(0, 2);
    } else {
      this._century = century;
      if (new Date().getFullYear() - parseInt(century + year, 10) < 100) {
        this._sep = "-";
      } else {
        this._sep = "+";
      }
    }
    this._year = year;
    this._fullYear = this._century + year;
    this._month = month;
    this._day = day;
    this._num = num;
    this._check = check;
    if (!this.valid()) {
      throw new PersonnummerError();
    }
  }
  valid() {
    const valid = luhn(this.year + this.month + this.day + this.num) === +this.check && !!this.check;
    if (valid && testDate(parseInt(this.century + this.year), +this.month, +this.day)) {
      return valid;
    }
    return valid && testDate(parseInt(this.century + this.year), +this.month, +this.day - 60);
  }
  format(longFormat = false) {
    if (longFormat) {
      return `${this.century}${this.year}${this.month}${this.day}${this.num}${this.check}`;
    }
    return `${this.year}${this.month}${this.day}${this.sep}${this.num}${this.check}`;
  }
  getAge() {
    let ageDay = +this.day;
    if (this.isCoordinationNumber()) {
      ageDay -= 60;
    }
    const ageDate = this.century + this.year + "-" + this.month + "-" + (ageDay < 10 ? "0" + ageDay : ageDay);
    return diffInYears(new Date(Date.now()), new Date(ageDate));
  }
  isCoordinationNumber() {
    return testDate(parseInt(this.century + this.year), +this.month, +this.day - 60);
  }
  isFemale() {
    return !this.isMale();
  }
  isMale() {
    const sexDigit = parseInt(this.num.substr(-1));
    return sexDigit % 2 === 1;
  }
};
var src_default = Personnummer;

// src/utils.ts
var luhn2 = (str) => {
  let sum = 0;
  str += "";
  for (let i = 0, l = str.length; i < l; i++) {
    let v = parseInt(str[i]);
    v *= 2 - i % 2;
    if (v > 9) {
      v -= 9;
    }
    sum += v;
  }
  return sum % 10 === 0;
};

// src/errors.ts
var OrganisationsnummerError = class extends Error {
  constructor() {
    super("Invalid Swedish organization number");
  }
};

// src/index.ts
var Organisationsnummer = class {
  constructor(input) {
    this.number = "";
    this.parse(input);
  }
  parse(input) {
    try {
      const reg = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([-+]?)?((?!000)\d{3})(\d)$/g;
      const match = reg.exec(input);
      if (!match) {
        throw new OrganisationsnummerError();
      }
      const number = input.replace("-", "");
      if (match[1] && +match[1] !== 16) {
        throw new OrganisationsnummerError();
      }
      if (+match[3] < 20) {
        throw new OrganisationsnummerError();
      }
      if (+match[2] < 10) {
        throw new OrganisationsnummerError();
      }
      if (!luhn2(number)) {
        throw new OrganisationsnummerError();
      }
      this.number = number;
    } catch (err) {
      try {
        this._personnummer = src_default.parse(input);
      } catch (_) {
        throw err;
      }
    }
  }
  static parse(input) {
    return new Organisationsnummer(input);
  }
  static valid(input) {
    try {
      this.parse(input);
      return true;
    } catch (err) {
      return false;
    }
  }
  format(separator = true) {
    let number = this.number;
    if (this.isPersonnummer()) {
      number = this._personnummer.format(true).slice(2, 12);
    }
    return separator ? number.slice(0, 6) + "-" + number.slice(6) : number;
  }
  personnummer() {
    return this._personnummer || null;
  }
  isPersonnummer() {
    return !!this._personnummer;
  }
  type() {
    if (this.isPersonnummer()) {
      return "Enskild firma";
    }
    const unkown = "Ok\xE4nt";
    const types = {
      1: "D\xF6dsbon",
      2: "Stat, landsting, kommun eller f\xF6rsamling",
      3: "Utl\xE4ndska f\xF6retag som bedriver n\xE4ringsverksamhet eller \xE4ger fastigheter i Sverige",
      5: "Aktiebolag",
      6: "Enkelt bolag",
      7: "Ekonomisk f\xF6rening eller bostadsr\xE4ttsf\xF6rening",
      8: "Ideella f\xF6rening och stiftelse",
      9: "Handelsbolag, kommanditbolag och enkelt bolag"
    };
    return types[+this.number[0]] || unkown;
  }
  vatNumber() {
    return `SE${this.format(false)}01`;
  }
};
var src_default2 = Organisationsnummer;
export {
  src_default2 as default
};
